import { apis } from 'ui-common'

export default {
  getLanguages: () => apis.$get('/languages')
}
